import { Badge } from "./badges.interface";

export const BADGES: Badge[] = [
  {
    label: "productivity-rocket",
    url: "https://storage.googleapis.com/prod_gsignature_user_images/gsignature.com/media/images/2025-04-24T13:37:29.398Z_7a783fa1-bb72-4ca6-abc9-34fcd6bea199",
  },
  {
    label: "team-pillar",
    url: "https://storage.googleapis.com/prod_gsignature_user_images/gsignature.com/media/images/2025-04-24T13:39:49.031Z_36afa46b-044d-485b-9c43-1ae03103533f",
  },
  {
    label: "innovator-of-month",
    url: "https://storage.googleapis.com/prod_gsignature_user_images/gsignature.com/media/images/2025-04-24T13:39:52.010Z_36c8c545-8e44-4a48-a046-dc9dfadf21d5",
  },
  {
    label: "customer-first",
    url: "https://storage.googleapis.com/prod_gsignature_user_images/gsignature.com/media/images/2025-04-24T13:39:55.581Z_3f6f38b6-6965-4d15-b8d9-53c6b7b3a0db",
  },
  {
    label: "quality-champion",
    url: "https://storage.googleapis.com/prod_gsignature_user_images/gsignature.com/media/images/2025-04-24T13:39:59.153Z_8fac55ad-b83c-4217-a320-0adb0853adfe",
  },
  {
    label: "unsung-hero",
    url: "https://storage.googleapis.com/prod_gsignature_user_images/gsignature.com/media/images/2025-04-24T13:40:05.010Z_79915f08-a644-4f8b-b36d-3d8051509f7a",
  },
  {
    label: "leader-of-month",
    url: "https://storage.googleapis.com/prod_gsignature_user_images/gsignature.com/media/images/2025-04-24T13:40:08.106Z_b09df0b3-d440-4715-9a20-89c7a9ed2b3b",
  },
  {
    label: "knowledge-expert",
    url: "https://storage.googleapis.com/prod_gsignature_user_images/gsignature.com/media/images/2025-04-24T13:40:11.681Z_e23efdae-d5cc-40b9-bc0d-c0aa8f5c756b",
  },
  {
    label: "deadline-keeper",
    url: "https://storage.googleapis.com/prod_gsignature_user_images/gsignature.com/media/images/2025-04-24T13:40:14.493Z_becbdfd0-3bad-4bc7-ba6f-ac9cecb773ae",
  },
  {
    label: "super-positive",
    url: "https://storage.googleapis.com/prod_gsignature_user_images/gsignature.com/media/images/2025-04-24T13:40:18.206Z_b980ea38-00a9-44b9-b4b6-18fee1c8e473",
  },
];
